import React from "react"

export function Union({ fill = "#4F4ACC", h = 12, w = 12 }: { fill?: string; h?: number; w?: number }) {
  return (
    <svg width={w} height={h} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.2 1.2C7.2 0.537258 6.66274 0 6 0C5.33726 0 4.8 0.537258 4.8 1.2L4.8 4.8H1.2C0.537258 4.8 0 5.33726 0 6C0 6.66274 0.537258 7.2 1.2 7.2H4.8V10.8C4.8 11.4627 5.33726 12 6 12C6.66274 12 7.2 11.4627 7.2 10.8L7.2 7.2H10.8C11.4627 7.2 12 6.66274 12 6C12 5.33726 11.4627 4.8 10.8 4.8H7.2L7.2 1.2Z"
        fill={fill}
      />
    </svg>
  )
}
